import { useCallback, useEffect } from 'react';

export const useScrollEndDetector = (ref: React.RefObject<HTMLDivElement>, onEndReached?: () => void, offset = 300) => {
    const handleScroll = useCallback(() => {
        const el = ref.current;
        if (!el || !onEndReached) return;

        const { scrollTop, scrollHeight, clientHeight } = el;
        if (scrollTop + clientHeight >= scrollHeight - offset) {
            onEndReached();
        }
    }, [ref, onEndReached, offset]);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        let ticking = false;
        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };

        el.addEventListener('scroll', onScroll);
        return () => {
            el.removeEventListener('scroll', onScroll);
        };
    }, [handleScroll, ref]);
};
